import axiosInstance from './axiosConfig';

// Server errors must reach the UI as Error objects: every caller reads `err.message`.
// Throwing a bare string made `err.message` undefined and hid the real 4xx reason.
const toError = (error, fallback) => {
  const data = error?.response?.data;
  const err = new Error(data?.message || fallback);
  err.code = data?.code;
  err.status = error?.response?.status;
  return err;
};

const disbursementsAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/disbursements', { params });
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to fetch disbursements');
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/disbursements/${id}`);
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to fetch disbursement');
    }
  },

  create: async (disbursementData) => {
    try {
      const response = await axiosInstance.post('/disbursements', disbursementData);
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to create disbursement');
    }
  },

  update: async (id, disbursementData) => {
    try {
      const response = await axiosInstance.put(`/disbursements/${id}`, disbursementData);
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to update disbursement');
    }
  },

  post: async (id) => {
    try {
      const response = await axiosInstance.post(`/disbursements/${id}/post`);
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to post disbursement');
    }
  },

  void: async (id, payload = {}) => {
    try {
      const response = await axiosInstance.post(`/disbursements/${id}/void`, payload);
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to void disbursement');
    }
  },

  generateReferenceNo: async (accountingClient) => {
    try {
      const response = await axiosInstance.get('/disbursements/generate-reference-no', {
        params: { accountingClient }
      });
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to generate reference number');
    }
  },

  getAuditTrail: async (id) => {
    try {
      const response = await axiosInstance.get(`/disbursements/${id}/audit-trail`);
      return response.data;
    } catch (error) {
      throw toError(error, 'Failed to fetch audit trail');
    }
  }
};

export default disbursementsAPI;
